module.exports = __webpack_public_path__ + "dashboard/img/road-barrier.7e7ad737139f9f7a7030b0ae5038b924.svg";